import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalIaActivityDescriptionPageRoutingModule } from './modal-ia-activity-description-routing.module';

import { ModalIaActivityDescriptionPage } from './modal-ia-activity-description.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalIaActivityDescriptionPageRoutingModule
  ],
  declarations: [ModalIaActivityDescriptionPage]
})
export class ModalIaActivityDescriptionPageModule {}
